import { UrlApi } from "../../../../../../services/apirest";

// Busca direcciones de las sucursales autorizadas aplicando los filtros elegidos.
export const buscarDireccionesSucAuth = async (sucursales, searchTerm, filtros) => {
  const searchParams = new URLSearchParams({
    search: searchTerm.trim(),
    limit: 100,
    filtros: filtros.join(","),
  });

  const response = await fetch(
    UrlApi +
      `/envasado_direcciones_entrega/buscarDireccionesSucAuth/${sucursales.join(
        ",",
      )}?${searchParams}`,
  );

  if (!response.ok) {
    throw new Error(`Error HTTP: ${response.status}`);
  }

  return response.json();
};
